import { LinearOptimizationsLambdaFetch, awaitJSON, pollS3 } from '../../utils/fetch-utils';

// Triggered from the run Overview table's "Excel" cell -- generates and downloads the legacy
// media-plan spreadsheet for this run.
export const downloadMediaPlan = async (kpi: string, runId: string): Promise<void> => {
  const result = await LinearOptimizationsLambdaFetch('/optimizations', {
    params: { kpi, runId, xlsx: true }
  });
  const { filename } = await awaitJSON<{ filename: string }>(result);
  await pollS3({
    bucket: 'bpm-output',
    mimeType: 'application/vnd.ms-excel',
    filename,
    overloadFilename: `MediaPlan ${kpi} ${runId}.xlsx`
  });
};
